import gql from "graphql-tag";

export const queryNewPDPLayout = gql`
  query GetIsNewPDPLayout($productId: String!) {
    getNewPDPLayout(productId: $productId) {
      newPdpLayout
    }
  }
`;
